export default "__VITE_ASSET__BJKmPl6j__"